// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style.css
// module id = Q0/0
// module chunks = 1